import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PlatInstrumentTablesComponent } from '../plat-instrument-tables';


/**
* Component of table of the diameter-specific plate instrument consumables.
*/
@Component({
	selector: 'plat-instrument-consum-tables',
	templateUrl: './plat-instrument-consum-tables.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PlatInstrumentConsumTablesComponent extends PlatInstrumentTablesComponent {

	@Input() isJPSExtension: boolean = false;

}
